import styled from "styled-components";
import { IStyleProps } from "@mindmemobile/mm-shared-global";
import { LabelCell } from "./Layout.styles";

export const PropertyButtons = styled.div<IStyleProps>`
  height: auto;
  width: ${(props) => props.width || "90px"};
  min-width: ${(props) => props.minWidth || "90px"};
  font-size: ${(props) => props.fontSize || "14px"};
  font-weight: 400;
  padding: 6px 10px;
  background: #eee;
  border-radius: 4px;
  color: ${(props) => props.color || "#555"};
  max-width: ${(props) => props.maxWidth || "125px"};

  &.text-ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: auto;
  }

  &.no-ellipsis {
    white-space: normal;
    word-wrap: break-word;
    width: unset;
    max-width: unset;
  }
`;

export const ProductDetailWrapper = styled.div<IStyleProps>`
  .label-description-row {
    margin: ${(props) => props.margin || "0px 0px 30px"};
    > div {
      padding: 0px;
      /* > label {
                &:not(.prc-multi-label, .standard-lh) {
                    line-height: 40px;
                }
                &.prc-multi-label {
                    margin-top: 5px;
                    width: 150px;
                    line-height: 22px;
                }
                &.standard-lh {
                    line-height: normal;
                }
            } */
    }
    i {
      margin-left: 10px;
      &.fa-chevron-right {
        margin-top: 7px;
      }
    }
    .styled-chkbox {
      margin-top: 8px;
      &.chkbox-no-margin {
        margin: 0px;
      }
    }
    .fa-pricing-page {
      font-size: 24px;
      margin-top: 3px;
    }
    .prc-multi-input {
      .error-border {
        width: 402px;
        border-radius: 5px;
      }
    }
    &.collapsed-labels {
      margin-top: 30px;
    }
    &.payment-sub-row {
      margin: 0px 0px 20px;
    }
  }

  .single-select-wrapper {
    &.pricing-option-dropdown {
      > div {
        width: 220px;
      }
    }
    .searchable-dropdown-input {
      width: 100%;
      border: none;
      border-bottom: 1px solid #ccc;
      border-radius: 0px;
      padding: 0px;
    }
  }
  .variant-Options {
    margin-top: 20px;
    > div {
      max-width: 1240px;
    }
  }
  .media-cards {
    img {
      height: 110px;
      width: 110px;
      cursor: pointer;
    }
  }
  .variant-section {
    width: 350px;
  }
  .prc-multiselect {
    min-height: 60px;
  }
  .prc-restr-input {
    width: 220px;
    input {
      width: 100%;
    }
  }
  .return-days-input {
    margin-left: 40px;
    input {
      height: 40px;
      width: 70px;
      &::placeholder {
        text-align: center;
      }
    }
  }
  .variant-header {
    margin: 20px 0px 20px 0px;
    .attr-headers {
      width: 170px;
    }
    .attr-options {
      width: calc(100% - 170px);
    }
  }
  .variant-desc-edit {
    height: 14px;
    width: 13px;
    margin: 0px 6px 1px 5px;
  }
  .variant-edit-icon {
    height: 15px;
    width: 15px;
    margin-bottom: 2px;
    cursor: pointer;
  }
  .variant-trash-icon {
    height: 16px;
    width: 19px;
    margin-bottom: 3px;
    cursor: pointer;
  }
  .variant-sort-icon {
    margin-bottom: 3px;
  }
  .variant-add-package {
    margin-top: 25px;
    margin-bottom: 35px;
  }
  .prc-multiselect__control {
    min-height: 50px;
    width: 400px;
    &:focus {
      outline: none;
    }
  }
  .prc-multiselect__menu {
    max-width: 400px;
  }
  .prc-multiselect__clear-indicator {
    cursor: pointer;
  }
  .prod-name-input {
    width: 400px;
  }
  .advanced-row-margin {
    margin-top: 50px;
  }
  .barcode-input {
    width: 300px;
  }
  .invent-sub-chkbox {
    padding-left: 36px;
    padding-top: 10px;
    .styled-chkbox:not(:last-child) {
      margin-bottom: 15px;
    }
    .span.invent-promo-chkbox {
      .styled-chkbox {
        margin-bottom: 0px;
      }
    }
  }
  .add-package-btn {
    background: no-repeat;
    color: #586db9;
    border: none;
    font-size: 14px;
    padding: 0px 40px 0px 0px;
    line-height: 16px;
    min-width: 130px;
    /* margin-left: 40px; */
    /* margin-bottom: 15px; */

    > img {
      margin-right: 7px;
      vertical-align: initial;
      height: 15px;
      width: 15px;
    }
    > span {
      margin-top: 2px;
    }
    &:active,
    &:focus,
    &:hover {
      outline: none;
      background-color: #fff;
      border: none;
      color: #586db9;
    }
  }
  .variant-table {
    table {
      width: 1300px;
      th {
        &:first-child {
          text-align: left;
          padding-left: 25px;
          position: sticky;
        }
      }

      td {
        &:first-child {
          padding-left: 25px;
          position: sticky;
        }
        &:last-child {
          width: 80px;
          max-width: 80px;
          min-width: 80px;
        }
      }
    }
  }
  .return-days-chkbox {
    input {
      height: 40px;
      width: 60px;
      border: 1px solid #aaa;
    }
    &.label-description-row {
      margin: 0px;
      flex-direction: row-reverse;
      gap: 10px;
      > div:last-child {
        flex: 0;
      }
    }
    ${LabelCell} {
      width: auto;
    }
  }
  .reorder-checkbox {
    .styled-chkbox {
      margin-top: 3px;
    }
  }
  .limit-qty-input {
    width: 100px;
  }
  .variant-chkbx-label {
    .form-check-input {
      height: 17px;
      width: 17px;
    }
    font-size: 14px;
  }
  .limit-qty-input {
    width: 100px;
  }
  .chkout-float-aside {
    width: calc(100% - 800px);
  }
  .merchant-status-row label {
    line-height: 40px !important;
  }
  table.no-border-last-child {
    margin-bottom:0px;
    tr:last-child {
      td {
        border-bottom: 0px;
      }
    }
  }
`;
